// With.apnaaapan site configuration. Change URLs and contact details here only.

// With.apnaaapan lives on its own host, https://with.apnaaapan.com, served by the same build as
// apnaaapan.com. On that host its pages sit at the root (/apply, /community ...). On any other host
// (local development, previews) they sit under /with. Production redirects apnaaapan.com/with/* to
// the subdomain, so each page has one canonical URL.
export const WITH_ORIGIN = 'https://with.apnaaapan.com';

/** True on with.apnaaapan.com (and with.localhost for local testing). */
export const isWithHost = (hostname = typeof window !== 'undefined' ? window.location.hostname : '') => /^with\./i.test(hostname);

export const WITH_BASE = isWithHost() ? '' : '/with';

/** Build a With.apnaaapan path: withPath('/apply') -> '/apply' on the subdomain, '/with/apply' elsewhere. */
export const withPath = (path = '/') => {
  if (!WITH_BASE) return path;
  return path === '/' ? WITH_BASE : `${WITH_BASE}${path}`;
};

export const PARENT_URL = 'https://www.apnaaapan.com';

export const CONTACT = {
  email: 'grow@apnaaapan.com',
  phoneDisplay: '+91 95877 73274',
  phoneHref: 'tel:+919587773274',
  whatsapp: 'https://wa.me/919587773274?text=Hi%2C%20I%27m%20writing%20about%20With.apnaaapan.',
  city: 'Jaipur, Rajasthan',
};

// Only links that exist are rendered. Add the LinkedIn company page URL when it is confirmed.
export const SOCIAL = {
  instagram: 'https://instagram.com/apnaaapan',
  linkedin: process.env.REACT_APP_WITH_LINKEDIN_URL || '',
};

// Real photos from Apnaaapan get-togethers (public/images). No stock photography.
export const PHOTOS = {
  group: { src: '/images/life_apnaaapan1.webp', alt: 'Seven friends from the Apnaaapan circle smiling together at an evening get-together', w: 1920, h: 1280 },
  speaker: { src: '/images/Our_Story1.webp', alt: 'A member sharing a story with the room during an Apnaaapan session', w: 2624, h: 3936 },
  polaroids: { src: '/images/Our_story2.webp', alt: 'A wall of polaroid photos from past get-togethers', w: 1920, h: 1280 },
  hug: { src: '/images/Our_story3.webp', alt: 'Four friends laughing with their arms around each other', w: 1920, h: 1280 },
  crowd: { src: '/images/apnaaapan_team.webp', alt: 'A full room of people posing for a group photo after an Apnaaapan evening', w: 1920, h: 1280 },
  wall: { src: '/images/life_apnaaapan2.webp', alt: 'Friends posing in front of a painted wall', w: 1280, h: 853 },
  studio: { src: '/images/life_apnaaapan4.webp', alt: 'Friends in festive kurtas at the Apnaaapan studio', w: 1920, h: 1078 },
};
